import { createApi } from 'effector';
import { createGate } from 'effector-react';
import type {
  LibItemArticle,
  LibItemModal3d,
  LibItemScrollList,
  LibItemSysAudio,
  LibItemSysIcon,
  LibType,
} from '@types';
import domain from '../domain';
import libReset from '../actions/libReset';
import onAlbumClick from '../actions/onAlbumClick';

export const LibMultipleGate = createGate<boolean>({
  domain,
  defaultState: false,
});

export const LibItemsGate = createGate<
  | LibItemScrollList[]
  | LibItemSysAudio[]
  | LibItemArticle[]
  | LibItemSysIcon[]
  | LibItemModal3d[]
>({
  domain,
  defaultState: [],
});

export const LibAddedSetGate = createGate<
  Partial<
    Record<LibType.pano | LibType.panoVideo | LibType.matrix, Set<number>>
  >
>({ domain });

export const LibAddedModel3dGate = createGate<Set<string>>({ domain });

export const $libSearch = domain
  .store<string>('')
  .reset(libReset, onAlbumClick);
export const $libSearchApi = createApi($libSearch, {
  set: (_, val: string) => val,
  clear: () => '',
});

export const $libAlbumId = domain
  .store<number>(0)
  .on(onAlbumClick, (_, id) => id)
  .reset(libReset);

export const LibDateTypeGate = createGate<'createDate' | 'updateDate'>({
  domain,
  defaultState: 'updateDate',
});
